export function omit<T extends object, K extends keyof T>(obj: T, keys: K[]): Omit<T, K> {
  return Object.fromEntries(Object.entries(obj).filter(([key]) => !keys.includes(key as K))) as unknown as Omit<T, K>;
}

export function scientificToDecimal(value: string | number): string {
  let number = String(value);
  const numberHasSign = number.startsWith('-') || number.startsWith('+');
  const sign = numberHasSign ? number[0] : '';
  number = numberHasSign ? number.replace(sign, '') : number;

  //if the number is in scientific notation remove it
  if (/\d+\.?\d*e[\\+\\-]*\d+/i.test(number)) {
    const zero = '0';
    const parts = String(number).toLowerCase().split('e'); //split into coeff and exponent
    const e = parts.pop(); //store the exponential part
    const coeffArray = parts[0].split('.');
    let numberOfZeros = Math.abs(Number(e));
    const sign = Number(e) / numberOfZeros;

    if (sign === -1) {
      coeffArray[0] = Math.abs(Number(coeffArray[0])).toString();
      number = zero + '.' + new Array(numberOfZeros).join(zero) + coeffArray.join('');
    } else {
      const dec = coeffArray[1];
      dec && (numberOfZeros = numberOfZeros - dec.length);
      number = coeffArray.join('') + new Array(numberOfZeros + 1).join(zero);
    }
  }

  return `${sign}${number}`;
}

export function toCamelCase(str: string): string {
  return str[0].toLowerCase() + str.slice(1);
}

export function generateKey(length = 9): string {
  let key = '';

  while (key.length < length) {
    key += Math.random().toString(36).slice(2);
  }

  return key.slice(0, length);
}

/** Tries `navigator.clipboard`; falls back to `execCommand('copy')` when policy blocks the Clipboard API. */
export async function copyTextToClipboard(text: string): Promise<boolean> {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // Permissions policy or other restrictions — use fallback
    }
  }

  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    textarea.style.top = '0';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    const success = document.execCommand('copy');
    document.body.removeChild(textarea);
    return success;
  } catch {
    return false;
  }
}
